// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentsAddMethod_container__2GtQW","footer":"PaymentsAddMethod_footer__2TXg2","form":"PaymentsAddMethod_form__1-wny","switch":"PaymentsAddMethod_switch__iCe0P"};